import React, { Fragment } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";

import Home from "./pages/Home";
import Loader from "./component/reusable/Loader.js";

import ScrollToTop from "./component/reusable/ScrollToTop.js";
import { useAuth } from "./context/userContext.js";
import RedirectSpinner from "./component/reusable/RedirectSpinner.js";
import StudentProfile from "./pages/StudentProfile.js";
import SideSocialIcons from "./component/reusable/SideSocialIcons.js";
import Sitemap from "./pages/Sitemap.js";
import NotificationPrompt from "./component/reusable/Notification.js";



const App = () => {
  const { auth } = useAuth();
  const user = auth?.user;
  const loading = auth?.loading;
  const isAuthenticated = auth?.isAuthenticated;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <ToastContainer />
          <ScrollToTop />
          <SideSocialIcons />
          <NotificationPrompt />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/sitemap" element={<Sitemap />} />
    
            <Route path="/login" element={<Login />} />            
          
            {/* Routes For Student Start */}
            <Route
              path="/student"
              element={
                isAuthenticated && user?.role === "11" ? (
                  <Outlet />
                ) : (
                  <RedirectSpinner />
                )
              }
            >
              <Route path="profile" element={<StudentProfile />} />
             
            </Route>
            {/* Routes For Student Ends */}

            

          </Routes>
        </Fragment>
      )}
    </>
  );
};

export default App;
